import styled from "styled-components";
import Button from "./Button";


export const TransparentButton = styled(Button)`
    background-color: transparent;
    color: #969696;
    font-weight: normal;
`;


// WEBPACK FOOTER //
// ./src/components/Button/TransparentButton.js